import { getOperatingSystem } from "../../../../util/common";
import { IAmplifyProvider } from "./amplifyProvider";
import type { IlocalStorageProvider } from "./localStorageProvider";

export type IPushNotificationProvider = ReturnType<
  typeof PushNotificationProviderFactory
>;

export const PushNotificationProviderFactory = ({
  circadiaEngineProvider,
  localStorageProvider,
  APIProvider,
  amplifyProvider,
  AuthService,
  apiRoute,
}: {
  circadiaEngineProvider: ICircadiaEngineProvider;
  localStorageProvider: IlocalStorageProvider;
  APIProvider: IAPIProvider;
  amplifyProvider: IAmplifyProvider;
  AuthService: IAuthService;
  apiRoute: string;
}) => {
  const { PUT, DELETE } = APIProvider;

  const getFCMToken = async () => {
    const token = await window.electron.getFCMToken();
    if (token.status === "success") {
      return token.token!;
    }
    return null;
  };

  const getToken = async () => {
    let notificationToken: string | null = null;

    if (window.electron) {
      notificationToken = await getFCMToken();
    } else {
      notificationToken = await circadiaEngineProvider.getDeviceToken();
    }

    return notificationToken;
  };

  const registerDeviceForPushNotifications = async () => {
    const notificationToken = await getToken();
    if (!notificationToken) {
      console.warn("Error, Fetching Notification Token ");
      return { success: false };
    }

    const { getAuthenticationToken } = AuthService;
    const payloadToSend = {
      notification_token:
        getOperatingSystem({ circadiaEngineProvider }) === "android"
          ? String(notificationToken).trim()
          : String(notificationToken).trim().replace(/\0/g, ""),
      os_type: getOperatingSystem({ circadiaEngineProvider }),
    };
    let deviceNotificationResponse = "";
    try {
      if (window.electron || circadiaEngineProvider.isWindowCircadia()) {
        deviceNotificationResponse = await PUT(apiRoute, payloadToSend, {
          Authorization: `Bearer ${await getAuthenticationToken()}`,
        });
      }
    } catch (e) {
      console.error(deviceNotificationResponse, e);
    }

    return { success: true, data: deviceNotificationResponse };
  };

  const unregisterDeviceForPushNotifications = async () => {
    const notificationToken = await getToken();
    if (!notificationToken) {
      console.warn("Error, Fetching Notification Token ");
      return { success: false };
    }

    const { getAuthenticationToken } = AuthService;

    let deviceNotificationResponse = "";
    try {
      if (window.electron || circadiaEngineProvider.isWindowCircadia()) {
        deviceNotificationResponse = await DELETE(
          apiRoute,
          {
            notification_token:
              getOperatingSystem({ circadiaEngineProvider }) === "android"
                ? String(notificationToken).trim()
                : String(notificationToken).trim().replace(/\0/g, ""),
            os_type: getOperatingSystem({ circadiaEngineProvider }),
          },
          {
            Authorization: `Bearer ${await getAuthenticationToken()}`,
          }
        );
      }
    } catch (e) {
      console.error(deviceNotificationResponse, e);
    }

    return { success: true, data: deviceNotificationResponse };
  };

  return {
    registerDeviceForPushNotifications,
    unregisterDeviceForPushNotifications,
  };
};
